/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import { forwardRef } from 'react'
import Icon from '../../icon/icon'

const FacebookIconSvg = forwardRef((props, svgRef) => (
	<svg
		width={props.width || (props.height && Math.floor(+props.height * 1)) || 24}
		height={props.height || (props.width && Math.floor(+props.width / 1)) || 24}
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		fontSize="medium"
		ref={svgRef}
		{...props}
	>
		<path
			d="M14.02 22.757v-9.468h3.19l.477-3.69H14.02V7.243c0-1.068.298-1.796 1.835-1.796l1.96-.001v-3.3C17.478 2.1 16.314 2 14.96 2c-2.827 0-4.762 1.72-4.762 4.877V9.6H7v3.69h3.197v9.468h3.823z"
			fill="currentColor"
			fillRule="evenodd"
		/>
	</svg>
))
FacebookIconSvg.displayName = 'FacebookIconSvg'

const FacebookIcon = forwardRef((props, ref) => <Icon component={FacebookIconSvg} ref={ref} {...props} />)
FacebookIcon.displayName = 'FacebookIcon'

FacebookIcon.defaultProps = {
	...Icon.defaultProps,
}
FacebookIcon.propTypes = {
	...Icon.propTypes,
}

export default FacebookIcon
export { FacebookIconSvg }
